<template>
    <div>
        <pageCard v-if="!flag" pagename='新闻中心' desc='CENTER OF NEWS' bg='news-top.png' mb='首页>新闻中心'/>
        <router-view />
    </div>
</template>

<script>

import pageCard from '../../components/page-card/index'
import {mapState} from 'vuex';
export default {
    components : {
        pageCard
    },
    computed:mapState({
        flag : state => state.flag
    }),
}
</script>